import { render, staticRenderFns } from "./EndStopsCard.vue?vue&type=template&id=87566fb0&"
import script from "./EndStopsCard.vue?vue&type=script&lang=ts&"
export * from "./EndStopsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports